export const OUTBOX_REPLAY_MIGRATION_SQL = `
ALTER TABLE outbox ADD COLUMN lease_token TEXT;
ALTER TABLE outbox ADD COLUMN next_attempt_at TEXT;
ALTER TABLE outbox ADD COLUMN last_error_code TEXT;
ALTER TABLE outbox ADD COLUMN last_error_message TEXT;
ALTER TABLE outbox ADD COLUMN terminal_error_code TEXT;
ALTER TABLE outbox ADD COLUMN terminal_error_message TEXT;
ALTER TABLE outbox ADD COLUMN settled_at TEXT;

UPDATE outbox
SET state = 'pending', lease_token = NULL, next_attempt_at = NULL
WHERE state = 'inflight' AND lease_expires_at IS NULL;

CREATE INDEX idx_outbox_domain_replay_order
  ON outbox(domain, replay_order);
CREATE INDEX idx_outbox_next_attempt
  ON outbox(state, next_attempt_at, replay_order);
`;
//# sourceMappingURL=005_outbox_replay.sql.js.map